<template>
  <div class="container">

    <div class="row mt-5">
      <div class="col-4"></div>
      <div class="col-4">

        <div class="login-header text-center mb-4">
          <div class="logo">
            <img src="./../../../img/logo.svg">
          </div>

          <div class="sub-header mt-2">
            Affiliate Kontrollpanel
          </div>
        </div>

        <div class="alert alert-danger" v-if="failed">
          Det angivna lösenordet är felaktigt
        </div>

        <div class="form-group">
          <label class="form-label">
            E-postadress
          </label>
          <input type="text" class="form-control" v-model="email">
        </div>

        <div class="form-group">
          <label class="form-label">
            Lösenord
          </label>
          <input type="password" class="form-control" v-model="password">
        </div>

        <div class="form-group text-center pt-4">
          <button type="button" class="btn btn-info" @click="login">
            <font-awesome-icon icon="sign-in-alt" />
            Logga in
          </button>
        </div>

      </div>
      <div class="col-4"></div>
    </div>

  </div>
</template>

<script>

  import Vue from 'vue'
  import {mapState} from 'vuex'

  export default {
    name: "Index",
    computed: {
      ...mapState({
        failed: state => state.auth.failed,
        affiliate: state => state.auth.affiliate,
      })
    },
    methods: {
      async login(){
        this.showLoader()

        await this.$store.dispatch('auth/password', this.$data)

        if(this.affiliate.email !== null){

          this.$cookies.set('authToken', this.affiliate.token, '2h')

          this.$router.push({name: 'dashboard'})
        }

        this.hideLoader()
      }
    },
    data(){
      return {
        email: null,
        password: null
      }
    },
    metaInfo() {
      return {
        title: 'Logga in'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Auth/Login.vue